import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-grid-system';
import { Link } from 'react-router-dom';

import ActionButton from 'SharedComponents/action-button';

import SelectSubscriptionPlan from 'SharedComponents/select-subscription'; 

import styles from './index.css';

const MemberPlansWrapper = styled.div`${styles}`;

const MemberPlans = () => {

  return(
    <MemberPlansWrapper>
      <div className="content-container" id="funds-we-pay-to">
        <h2 className="title">Pricing</h2>
        <div className="content">
          <p>Plans starting from $0.00 / month.</p>
            <Container fluid className="links-container" style={{ margin: 0, padding: 0, width: '100%' }}>
                <Row style={{ margin: 0, padding: 0, width: '100%', justifyContent: 'center'}}>
                  <Col xl={6} lg={6} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                  <div className="acceptance-card">
                    <h2 className="title">Subscription Plans</h2>
                    <SelectSubscriptionPlan
                      subscriptionFeaturesOn={true}
                    />
                  </div>
                  </Col>
                </Row>
            </Container>
        </div>
        <div className="button-container">
            <Link to="/signup"><ActionButton text="Sign Up Free" large={true} /></Link>
        </div>
      </div>

    </MemberPlansWrapper>
  );
};

export default MemberPlans;
